// components/Signatories/SignatoryDetailModal.js
import ReactDOM from 'react-dom';
import SignatoryDocumentsSection from './SignatoryDocumentsSection';

const SignatoryDetailModal = ({ isOpen, onClose, signatory }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadgeClass = (statut) => {
    switch (statut?.toLowerCase()) {
      case 'actif':
        return 'bg-success';
      case 'inactif':
        return 'bg-secondary';
      default:
        return 'bg-secondary';
    }
  };

  const getTypeSignatureBadgeClass = (type) => {
    switch (type) {
      case 'Seul':
        return 'bg-primary';
      case 'Conjointe':
        return 'bg-warning text-dark';
      case 'Multiple':
        return 'bg-info';
      default:
        return 'bg-secondary';
    }
  };

  return ReactDOM.createPortal(
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable modal-custom">
        <div className="modal-content">
          <div className="modal-header bg-white text-dark">
            <h5 className="modal-title d-flex align-items-center">
              <i className="fas fa-signature me-2 text-primary"></i>
              Détails du Signataire
            </h5>
            <button
              type="button"
              className="btn-close btn-close-primary"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            {signatory ? (
              <div className="row g-4">
                {/* Informations personnelles */}
                <div className="col-md-6">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-header bg-transparent">
                      <h6 className="mb-0">
                        <i className="fas fa-user text-info me-2"></i>
                        Informations Personnelles
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Nom complet</label>
                        <p className="mb-0 fw-semibold">
                          {signatory.firstName} {signatory.lastName}
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Email</label>
                        <p className="mb-0">
                          <a href={`mailto:${signatory.email}`} className="text-decoration-none">
                            {signatory.email}
                          </a>
                        </p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Poste</label>
                        <p className="mb-0">{signatory.position}</p>
                      </div>
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Nationalité</label>
                        <p className="mb-0">{signatory.nationalite}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Informations de signature */}
                <div className="col-md-6">
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-header bg-transparent">
                      <h6 className="mb-0">
                        <i className="fas fa-pen text-success me-2"></i>
                        Informations de Signature
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Type de signature</label>
                        <div>
                          <span className={`badge ${getTypeSignatureBadgeClass(signatory.typeSignature)}`}>
                            {signatory.typeSignature}
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Signataire principal</label>
                        <div>
                          <span className={`badge ${signatory.estSignatairePrincipal ? 'bg-success' : 'bg-secondary'}`}>
                            {signatory.estSignatairePrincipal ? 'Oui' : 'Non'}
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Représentant légal</label>
                        <div>
                          <span className={`badge ${signatory.estRepresentantLegal ? 'bg-info' : 'bg-secondary'}`}>
                            {signatory.estRepresentantLegal ? 'Oui' : 'Non'}
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label small text-muted mb-1">Source de création</label>
                        <p className="mb-0">{signatory.creationSource}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Adresse et statut */}
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-transparent">
                      <h6 className="mb-0">
                        <i className="fas fa-map-marker-alt text-warning me-2"></i>
                        Adresse et Statut
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <label className="form-label small text-muted mb-1">Adresse</label>
                          <p className="mb-0">{signatory.adresse}</p>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label small text-muted mb-1">Statut</label>
                          <div>
                            <span className={`badge ${getStatusBadgeClass(signatory.statut)}`}>
                              {signatory.statut}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label small text-muted mb-1">Date de création</label>
                          <p className="mb-0 small">{formatDate(signatory.creationDate)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Documents */}
                {(signatory.photoIdentite || signatory.cni || signatory.signatureSpecimen) && (
                    <div className="col-12">
                        {/* Section Documents avec notre nouveau composant */}
                        <SignatoryDocumentsSection 
                            signatoryId={signatory.id}
                            signatoryName={`${signatory.firstName} ${signatory.lastName}`}
                        />
                    </div>
                )}
              </div>
            ) : (
              <div className="text-center py-5">
                <i className="fas fa-exclamation-circle text-warning fa-3x mb-3"></i>
                <p className="text-muted">Aucune donnée disponible</p>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              <i className="fas fa-times me-1"></i>
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SignatoryDetailModal;